<template>
  <IndicatorWrapper class="tickets-avg" :class="{'compare': isCompareMode}" :status="status" v-if="visible">
    <div class="top">
      <TextWithFilters
        ref="textComponent"
        textKey="tickets_avg_text_with_filters"
        shareTextKey="tickets_avg_text_share"
        :textData="dynamicTextData"
        v-model="currentFilters"
      ></TextWithFilters>
    </div>
    <div class="bottom">
      <div class="bkg"/>
      <NumbersChart :filters="currentFilters" :data="chartData" :compareData="compareData"></NumbersChart>
      <ChartLegend :items="legendItems" v-show="isCompareMode"></ChartLegend>
      <ChartDescription :values="currentFilters" :indicator="indicator" descriptionKey="tickets_avg_info"></ChartDescription>
    </div>
  </IndicatorWrapper>
</template>

<script>
import Api from '@/api'
import indData from '@/mixins/indData'
import indDynamicText from '@/mixins/indDynamicText'
import TextWithFilters from '@/components/IndicatorCards/parts/TextWithFilters'
import NumbersChart from '@/components/IndicatorCards/parts/charts/NumbersChart'
import ChartDescription from '@/components/IndicatorCards/parts/ChartDescription'
import ChartLegend from '@/components/IndicatorCards/parts/ChartLegend'
import IndicatorWrapper from '@/components/IndicatorCards/parts/IndicatorWrapper'

export default {
  name: 'TicketsAvg',
  components: {
    TextWithFilters,
    NumbersChart,
    ChartDescription,
    IndicatorWrapper,
    ChartLegend
  },
  mixins: [indData, indDynamicText],
  computed: {
    indicatorData() {
      return {
        main_value: {
          required: true,
          get () {
            return Api.getIndicatorData('ind_avg_ticket',this.currentFilters)
          }
        },
        compare_data: {
          required: false,
          triggers_jump: false,
          get () {
            return this.isCompareMode ? Api.getIndicatorData('ind_avg_ticket',this.currentFilters, {
              node: this.compareNodeInfo,
              avoidCancel: true
            }) :
            Promise.resolve(false)
          }
        }
      }
    },
    dynamicTextData (){
      return [
        {
          type: 'select',
          id: 'timeScale',
        },
        {
          type: 'select',
          id: 'sector_ticket',
        },
        {
          type: 'value',
          id: 'VALUE_1',
          value: this.indicatorData.main_value && this.indicatorData.main_value.data[0] && this.indicatorData.main_value.data[0].value,
          unit: '€'
        }
      ]
    },
    
    chartData () {
      return this.indicatorData && this.indicatorData.main_value && this.indicatorData.main_value.data
    },
    compareData () {
      return this.indicatorData && this.indicatorData.compare_data && this.indicatorData.compare_data.data
    }
  }
  
}
</script>

<style lang="stylus" scoped>
.tickets-avg
  .bottom
    .compare &
    .desktop &
        margin-top: vh(-40px)
    .bkg
      background-image url('~@/assets/images/ticket.png')
      position: absolute;
      background-repeat: no-repeat;
      width 'calc(100% + %s)' % vw(10px)
      height 100%
      top: 0px;
      left: 0px;
      pointer-events none
      z-index 0
      .mobile &
        background-size: 50%;
        background-position: 100% 100%;
      .desktop &
        background-size: 25%;
        background-position: 100% 95%;
  .numbers-chart
    .mobile &
      flex 0 0 vh(220px)
  
  .chart-description
    flex: 0 0 auto;
</style>